export default __webpack_public_path__ + "static/media/customised-treatment.ef7c09a7.png";